"use strict";

import { spawnDialogWindow } from 'components/dialogHolder';
import { _I_, defineSimpleTerm } from 'components/locs';
import { BootButton, CloseButton } from 'generics/buttons';
import { IconFontAwesome, IconLanguage } from 'generics/icons';
import { getEnabledLocales } from 'generics/localeUtils';
import React from 'react';
import { SetGeneralSettings } from '../api/userSettingsAPICall';

export function spawnUserSettingsModal() {
  spawnDialogWindow(ViewUserSettingsDialog, {});
}


function setUsedLocale(code) {
  setCloudSettingProp("locale", code).then(() => {
    utils_api.setStored(["MarketApp", "LRU", "locale"], code);
    utils_api.sheduleReload();
  });
}

function setCloudSettingProp(prop, value) {
  let settings = utils_api.getStored(["MarketApp", "cloudSettings"]) || {};
  settings[prop] = value;
  return SetGeneralSettings(settings);
}

class CheckboxPrivateMode extends React.Component {

  constructor(props) {
    super(props);

    const getPrivateMode = utils_api.getStored(["MarketApp", "privateTradingState"]);

    this.state = {
      isChecked: !(getPrivateMode === false),
    };
  }

  toggleChange = () => {
    const privateMode = !this.state.isChecked;
    this.setState({
      isChecked: privateMode,
    });

    setCloudSettingProp("privateTradingState", privateMode).then(() => {
      utils_api.setStored(["MarketApp", "privateTradingState"], privateMode);
    });
  }

  render() {
    return (
      <div>
        <div className="label label-default text-center">
          {_I_("UserSettingsDialog.privacySettings")}
        </div>
        <div className="well well-sm view-user-settings-localeset">
          <div className="privateMode custom-control custom-checkbox">
            <input type="checkbox"
              className="custom-control-input"
              checked={this.state.isChecked}
              onChange={this.toggleChange}
            />
            <label
              className="custom-control-label"
              onClick={this.toggleChange}
            >
              {_I_("UserSettingsDialog.privacySettingsLabel")}
            </label>
          </div>
        </div>
      </div>
    );
  }
}

class CheckboxInterface extends React.Component {

  constructor(props) {
    super(props);

    const interfaceOldVersion = utils_api.getStored(["MarketApp", "interfaceOldVersion"]);

    this.state = {
      isChecked: interfaceOldVersion,
    };
  }

  toggleChange = (interfaceOldVersion) => {
    this.setState({
      isChecked: interfaceOldVersion,
    });

    setCloudSettingProp("interfaceOldVersion", interfaceOldVersion).then(() => {
      utils_api.setStored(["MarketApp", "interfaceOldVersion"], interfaceOldVersion);
    });
  }

  render() {
    return (
      <div>
        <div className="label label-default text-center">
          {_I_("UserSettingsDialog.interface")}
        </div>
        <div className="well well-sm view-user-settings-localeset">
          <div className="privateMode custom-control custom-checkbox">
            <input type="checkbox"
              className="custom-control-input"
              checked={this.state.isChecked}
              onChange={() => this.toggleChange(!this.state.isChecked)}
            />
            <label
              className="custom-control-label"
              onClick={() => this.toggleChange(!this.state.isChecked)}
            >
              {_I_("UserSettingsDialog.interfaceOld")}
            </label>
          </div>
        </div>
      </div>
    );
  }
}

export default class ViewUserSettingsDialog extends React.Component {
  constructor(props) {
    super(props);

    const currentLocale = SettingsInjections.getUsedLocale();

    this.state = {
      localeCode: currentLocale.code
    }
  }


  onBackdropTouch() {
    this.props.removeModal();
  }


  onSaveButton() {
    const currentLocale = SettingsInjections.getUsedLocale();
    if (currentLocale.code != this.state.localeCode) {
      setUsedLocale(this.state.localeCode);
    }
    this.props.removeModal();
  }


  renderLocales() {
    const items = getEnabledLocales().map(({ name, code, icon, enabled }, key) => {
      const isCurrent = (this.state.localeCode == code);
      return (<BootButton key={code}
        variant={isCurrent ? "success" : "default"}
        disabled={!enabled}
        onClick={() => this.setState({ localeCode: code })}
      >
        <IconLanguage code={icon} small labelNative labelEnglish />
      </BootButton>);
    });


    return (<div>
      <div className="label label-default text-center">
        {_I_("UserSettingsDialog.language")}
      </div>
      <div className="well well-sm view-user-settings-localeset">{items}</div>
    </div>);

  }

  render() {
    return (
      <div className="panel panel-primary panel-sm view-user-settings-dialog">
        <div className="panel-heading">
          <IconFontAwesome type="gear" fixedWidth />
          &nbsp;{_I_("UserSettingsDialog.user_settings")}
          <CloseButton onClick={this.props.removeModal} />
        </div>

        <div className="panel-body">
          <div className="text-center">
            <IconFontAwesome type="gear" size="3x" fixedWidth />
            &nbsp;<b>{_I_("UserSettingsDialog.settings")}</b>
          </div>
          {this.renderLocales()}
          <CheckboxPrivateMode />
          <CheckboxInterface />
          <div className="text-center">
            <hr />
            <BootButton variant="success" onClick={() => this.onSaveButton()} >
              <IconFontAwesome type="floppy-o" />&nbsp;{_I_("UserSettingsDialog.save_settings")}
            </BootButton>
          </div>
        </div>
      </div>
    );
  }



}

defineSimpleTerm("UserSettingsDialog.privacySettingsLabel", "anonymous trading mode", {
  "ru_RU": "режим приватной торговли",
  "cs_CZ": "anonymous trading mode",
  "fr_FR": "anonymous trading mode",
  "de_DE": "anonymous trading mode",
  "it_IT": "anonymous trading mode",
  "ko_KR": "anonymous trading mode",
  "pl_PL": "anonymous trading mode",
  "pt_PT": "anonymous trading mode",
  "es_ES": "anonymous trading mode",
  "zh_CN": "anonymous trading mode"
});

defineSimpleTerm("UserSettingsDialog.privacySettings", "Privacy settings", {
  "ru_RU": "Настройки приватности",
  "cs_CZ": "Privacy settings",
  "fr_FR": "Privacy settings",
  "de_DE": "Privacy settings",
  "it_IT": "Privacy settings",
  "ko_KR": "Privacy settings",
  "pl_PL": "Privacy settings",
  "pt_PT": "Privacy settings",
  "es_ES": "Privacy settings",
  "zh_CN": "Privacy settings"
});

defineSimpleTerm("UserSettingsDialog.interface", "Interface", {
  "ru_RU": "Интерфейс",
  "cs_CZ": "Interface",
  "fr_FR": "Interface",
  "de_DE": "Interface",
  "it_IT": "Interface",
  "ko_KR": "Interface",
  "pl_PL": "Interface",
  "pt_PT": "Interface",
  "es_ES": "Interface",
  "zh_CN": "Interface"
});

defineSimpleTerm("UserSettingsDialog.interfaceOld", "Use the old version of the exchange", {
  "ru_RU": "Использовать старую версию биржи",
  "cs_CZ": "Use the old version of the exchange",
  "fr_FR": "Use the old version of the exchange",
  "de_DE": "Use the old version of the exchange",
  "it_IT": "Use the old version of the exchange",
  "ko_KR": "Use the old version of the exchange",
  "pl_PL": "Use the old version of the exchange",
  "pt_PT": "Use the old version of the exchange",
  "es_ES": "Use the old version of the exchange",
  "zh_CN": "Use the old version of the exchange"
});

defineSimpleTerm("UserSettingsDialog.language", "Language", {
  "ru_RU": "Язык",
  "cs_CZ": "Jazyk",
  "fr_FR": "Langue",
  "de_DE": "Sprache",
  "it_IT": "Language",
  "ko_KR": "언어",
  "pl_PL": "Język",
  "pt_PT": "Language",
  "es_ES": "Language",
  "zh_CN": "语言"
});

defineSimpleTerm("UserSettingsDialog.user_settings", "User settings", {
  "ru_RU": "Настройки пользователя",
  "cs_CZ": "Uživatelské nastavení",
  "fr_FR": "Paramètres utilisateur",
  "de_DE": "Benutzereinstellungen",
  "it_IT": "User settings",
  "ko_KR": "유저 설정",
  "pl_PL": "Ustawienia użytkownika",
  "pt_PT": "User settings",
  "es_ES": "User settings",
  "zh_CN": "用户设置"
});

defineSimpleTerm("UserSettingsDialog.settings", "Settings", {
  "ru_RU": "Настройки",
  "cs_CZ": "Nastavení",
  "fr_FR": "Paramètres utilisateur",
  "de_DE": "Einstellungen",
  "it_IT": "Settings",
  "ko_KR": "설정",
  "pl_PL": "Ustawienia",
  "pt_PT": "Settings",
  "es_ES": "Settings",
  "zh_CN": "设置"
});

defineSimpleTerm("UserSettingsDialog.save_settings", "Save settings", {
  "ru_RU": "Сохранить настройки",
  "cs_CZ": "Uložit nastavení",
  "fr_FR": "Sauver les paramètres",
  "de_DE": "Einstellungen speichern",
  "it_IT": "Save settings",
  "ko_KR": "설정 저장",
  "pl_PL": "Zapisz ustawienia",
  "pt_PT": "Save settings",
  "es_ES": "Save settings",
  "zh_CN": "保存设置"
});



